<form
  [formGroup]="monitoringAreaRadiusForm"
  odxForm
  [readonly]="transmitter.locked || (isReferenceMeasureSet$ | async) === false"
>
  <odx-form-field i18n-label="@@editTransmitterForm.label.radius" label="Radius Überwachungsbereich (Meter)">
    <input
      type="number"
      min="1"
      formControlName="radius"
      odxFormFieldControl
      i18n-placeholder="@@editTransmitterForm.placeholder.radius"
      placeholder="Radius"
      [odxTooltip]="tooltipTextNoReferenceMeasure"
      [odxTooltipDisabled]="(isReferenceMeasureSet$ | async) === true"
    />
  </odx-form-field>
</form>
